import { Box, IconButton } from "@mui/material";

export const formatDate = (dateOfBirth) => {
    const options = { day: 'numeric', month: 'long' };
    const date = new Date(dateOfBirth);
    return date.toLocaleDateString(undefined, options);
};
export const getQuarterYear = (date) => {
    // Get the month of the date
    const month = date.getMonth();

    // Calculate the quarter
    let quarter;
    if (month < 3) {
        quarter = 4;
    } else if (month < 6) {
        quarter = 1;
    } else if (month < 9) {
        quarter = 2;
    } else {
        quarter = 3;
    }

    // Get the full year
    let year = date.getFullYear();

    // Adjust year for quarter 4 of previous year
    if (quarter === 4) {
        year -= 1;
    }

    // Format the output string
    return `Q${quarter} Updates ${year}`;
}

// export  const renderMoreIcons = (menus) => {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//         <IconButton
//           aria-label="more"
//           id="long-button"
//           onClick={(e) => handleClick(e, menus)}
//         >
//           <MoreVertIcon />
//         </IconButton>
//       </Box>
//     )
//   }